<template>
  <svg viewBox="-0.5 -0.5 21 21" fill="currentColor" stroke="currentColor" aria-hidden="true">
    <rect x="3" y="3" width="14" height="14" rx="7" stroke-width="3" fill="none" />
    <path stroke-width="2" d="M5,5 L 15,15" />
    <path stroke-width="2" d="M5,15 L 15,5" />
  </svg>
</template>
